import { css } from '@emotion/core';
import { tokens, applyFont, media } from '@domain-group/fe-brary';
var colors = tokens.colors,
  spacing = tokens.spacing,
  typography = tokens.typography;
export var container = {
  name: "pyfr22",
  styles: "padding-top:0;padding-bottom:0;display:flex;flex-wrap:wrap;"
};
export var avgRating = size => /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", size === 'l' && /*#__PURE__*/css(applyFont(typography.displaySmall), ";"), " ", size === 'm' && /*#__PURE__*/css(applyFont(typography.bodyBold), ";"), " ", ['s', 'sm'].includes(size) && /*#__PURE__*/css(applyFont(typography.captionBold), ";"), " ", size === 'xs' && /*#__PURE__*/css(applyFont(typography.mini), ";"), " ", media('<desktop'), "{", !['xs', 's', 'sm'].includes(size) && /*#__PURE__*/css(applyFont(typography.bodyBold), ";"), "}");
export var starRating = {
  name: "wluvts",
  styles: "padding:0 1px;"
};
export var totalReview = size => /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", applyFont(typography.body), ";text-decoration:none;margin-bottom:1px;a{cursor:pointer;}", ['xs', 's', 'sm'].includes(size) && /*#__PURE__*/css(applyFont(typography.mini), ";"));
export var ratings = /*#__PURE__*/css("display:flex;flex-wrap:wrap;align-items:center;gap:", spacing.xxs, ";");